<div class="div_venue div_menu_wrapper" style="width: 100%; min-width: calc(100% - 240px) !important;">
<div class="pos-title-header">
  <div class="d-flex align-items-center">
    <label class="lbl_top me-5">{{'SUPPLIERS.SUPPLIERS' | translate}}</label>
    <p-calendar #rangeCalendar class="touch-ui-date-picker suppliers-date-picker" placeholder="{{'SUPPLIERS.CHOOSE_DATE' | translate}}"
                [(ngModel)]="dateRange" selectionMode="range" [readonlyInput]="true" inputId="range" [touchUI]="isTouch"
                [firstDayOfWeek]="1" [numberOfMonths]="2" (onSelect)="loadSuppliersByVenueInDateRange()"></p-calendar>
  </div>
</div>
<div class="w-100 d-flex justify-content-center mt-3">
  <div class="d-flex flex-column justify-content-center suppliers-container">
    <div class="suppliers-table-container">
      <p-table [responsive]="true" [responsiveLayout]="'stack'" [scrollable]="false"  [value]="suppliersList" class="align-self-center w-100" [breakpoint]="'550px'">
        <ng-template pTemplate="header">
          <tr>
            <th class="pt-20px ellipsis">{{'SUPPLIERS.NAME' | translate}}</th>
            <th>{{'SUPPLIERS.TURNOVER' | translate}}</th>
            <th>{{'SUPPLIERS.ORDER_SUMMARY' | translate}}</th>
            <th class="pt-20px">{{'SUPPLIERS.ORDER_DETAILS' | translate}}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-supplier>
          <tr>
            <td>
              <b class="p-column-title">
                {{'SUPPLIERS.NAME' | translate}}
              </b>
              <div class="ellipsis">{{supplier.supplierName}}</div>
            </td>
            <td>
              <b class="p-column-title">
                {{'SUPPLIERS.TURNOVER' | translate}}
              </b>
              {{supplier.turnover}} {{currency}}
            </td>
            <td>
              <b class="p-column-title">
                {{'SUPPLIERS.ORDER_SUMMARY' | translate}}
              </b>
              {{supplier.ordersSummary}}
            </td>
            <td>
             <span (click)="openOrderDetailsPopup(supplier.supplierName,venueId!)"><i class="pi c-order-details-icon-magenta shopping-card-icon"></i></span>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

</div>
